
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import Ax from "../../../components/hoc/Ax";
import TopHeader from "../common/TopHeader";
import Footer from "../common/Footer";
import { toast } from "react-toastify";
import HttpAPICall from "../../../services/HttpAPICall";
import { APP_BASE_URL_2 } from "../../../services/TapApiUrls";
import TapIcon from "../../../services/TapIcon";
import api from "../../../services/api";
import TapHelper from "../../../services/TapHelper";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Documents from "./Documents";
import AssetDetails from "./AssetDetails";
import Compliance from "./Compliance";

const Asset = ({ assetId, passcode, mobile, onSessionExpired, mobileDisplay }) => {

    const history = useHistory()
    const accessToken = TapHelper.getPasscodeToken();
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [assetComplianceList, setAssetComplianceList] = useState([]);
    const [complianceLoading, setComplianceLoading] = useState(false);
    const [assetDocumentList, setAssetDocumentList] = useState([]);
    const [assetComplianceDocList, setAssetComplianceDocList] = useState([]);
    const [assetMatrixDocumentList, setAssetMatrixDocumentList] = useState([]);
    const [documentLoading, setDocumentLoading] = useState(false);
    const [listingMeta, setListingMeta] = useState(null);
    const [sessionExpiry, setSessionExpiry] = useState("28:45");
    const [assetDocuments, setAssetDocuments] = useState([]);
    const [assetMatrixDocuments, setAssetMatrixDocuments] = useState([]);

    useEffect(() => {
        getAssetDetails(assetId);
    }, [assetId]);

    const Info = ({ icon, title, value }) => (
        <div
            className="d-flex align-items-center"
            style={{
                gap: "clamp(8px, 1.2vw, 14px)",
            }}
        >
            <div
                style={{
                    width: "clamp(36px, 4vw, 44px)",
                    height: "clamp(36px, 4vw, 44px)",
                    background: "#F8FAFC",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                }}
            >
                <TapIcon.FontAwesomeIcon
                    icon={icon}
                    style={{
                        fontSize: "clamp(14px, 1.2vw, 18px)",
                    }}
                />
            </div>

            <div>
                <div
                    style={{
                        fontSize: "clamp(10px, 0.8vw, 12px)",
                        color: "#6B7A8F",
                        whiteSpace: "nowrap",
                    }}
                >
                    {title}
                </div>

                <div
                    style={{
                        fontWeight: 700,
                        fontSize: "clamp(12px, 1vw, 14px)",
                        whiteSpace: "nowrap",
                    }}
                >
                    {value || "-"}
                </div>
            </div>
        </div>
    );


    useEffect(() => {

        let seconds = Number(TapHelper.getPasscodeExpiry()) || 0;

        const timer = setInterval(() => {

            if (seconds <= 0) {
                clearInterval(timer);
                onSessionExpired();
                return;
            }

            seconds--;

            TapHelper.setPasscodeExpiry(seconds);

            const min = String(Math.floor(seconds / 60)).padStart(2, "0");
            const sec = String(seconds % 60).padStart(2, "0");

            setSessionExpiry(`${min}:${sec}`);

        }, 1000);

        return () => clearInterval(timer);

    }, []);
    const handleLogout = () => {
        onSessionExpired();

    };
    const getAssetDetails = (asset_id) => {
        setLoading(true);
        api.serverPasscodeApi
            .get(`${APP_BASE_URL_2}/passcode/asset/${asset_id}`, {
                headers: {
                    Authorization: "Bearer " + accessToken,
                },
            })
            .then((response) => {
                const data = response.data;
                setLoading(false);
                setDetails(data.asset);
                setAssetComplianceList(data.compliances || []);
                setAssetDocuments(data.asset_docs || []);
                setAssetMatrixDocuments(data.asset_matrix_docs || []);
            })
            .catch((err) => {
                setLoading(false);

                toast.error(
                    err?.response?.data?.message || "Unable to fetch asset details."
                );
            });
    };


    return (
        <>
            <TopHeader
                passcode={passcode}
                mobile={mobileDisplay}
                sessionExpiry={sessionExpiry}
                onLogout={handleLogout}
                showData={true}
            />
            <div className="page_containt">
                <div className="pageTbl">
                    <div
                        className="d-flex align-items-center justify-content-center flex-wrap d-md-none bg-white py-3 py-sm-2 px-3 px-sm-2"
                        style={{
                            border: "1px solid #E8ECF4",
                            gap: "clamp(14px, 1.8vw, 28px)",
                        }}
                    >
                        <Info
                            icon={TapIcon.faIdBadge}
                            title="Passcode"
                            value={passcode}
                        />

                        <Info
                            icon={TapIcon.faPhoneAlt}
                            title="Mobile"
                            value={mobile}
                        />

                        <Info
                            icon={TapIcon.faClock}
                            title="Session Expires In"
                            value={sessionExpiry}
                        />
                    </div>

                    <div className="row justify-content-center ">
                        <div className="col-12 col-md-11 mt-1  my-md-3">
                            <AssetDetails
                                details={details}
                                loading={loading}
                                error={error}
                            />
                            <div className="mt-2">
                                <Compliance
                                    assetComplianceList={assetComplianceList}
                                    complianceLoading={loading}
                                />
                            </div>

                            <div className="mt-3">
                                <Documents
                                    title="Asset Documents"
                                    documents={assetDocuments}
                                    loading={loading}
                                    emptyMessage="No asset documents found"
                                />
                            </div>

                            <div className="mt-3 mb-5">
                                <Documents
                                    title="Asset Matrix Documents"
                                    documents={assetMatrixDocuments}
                                    loading={loading}
                                    emptyMessage="No asset matrix documents found"
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>

    );
};

export default Asset;
